import React from 'react'

import KeyBoardWrapper from '@zet/common/components/keyboardWrapper'
import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { Button, H4, SH3, Stack } from '@zet/design-system'
import MyTeamsLogo from '@zet/design-system/svg/MyTeamsLogo.svg'
import ZetLogo from '@zet/design-system/svg/ZetLogo'
import { APP_NAME } from '@zet/end-points'

type ErrorScreenLayoutProps = {
  ErrorIconComponent: (props: any) => JSX.Element
  FooterComponent?: () => JSX.Element
  title: string
  description: string
  buttonTitle: string | null
  buttonOnPress?: () => void
}

export const ErrorScreenLayout = ({
  ErrorIconComponent = () => <></>,
  FooterComponent = () => <></>,
  title = '',
  description = '',
  buttonTitle = null,
  buttonOnPress,
}: ErrorScreenLayoutProps) => {
  return (
    <Stack className="bg-white px-3">
      <KeyBoardWrapper
        className="h-[100%]"
        BottomSheet={
          <Stack className="mb-3">
            <FooterComponent />
          </Stack>
        }
      >
        {/* Zet Icon */}
        <Stack className="mt-8 items-center">
          {APP_NAME === MY_TEAMS_ADVISOR ? <MyTeamsLogo /> : <ZetLogo />}
        </Stack>
        {/* Error Icon */}
        <Stack className="mt-8 items-center">
          <ErrorIconComponent />
        </Stack>
        {/* Title Description */}
        <Stack className="mt-8 items-center">
          <H4>{title}</H4>
          <SH3 className="text-grays-60 mt-2 text-center">{description}</SH3>
        </Stack>
        {/* Body */}
        <Stack className="mt-5 items-center pb-3">
          {buttonTitle && (
            <Button
              onPress={buttonOnPress && buttonOnPress}
              size="medium"
              outlined
              textStyle="text-primary-100"
            >
              {buttonTitle}
            </Button>
          )}
        </Stack>
      </KeyBoardWrapper>
    </Stack>
  )
}
